module.exports = __webpack_public_path__ + "static/media/STAF_bokmål med tjenesteløfte_primærlogo_positiv(svart).f4aa30a0.png";